export enum EPlatform {
  iOs = 'ios',
  Android = 'android',
}
